// Shared runtime namespace object. This replaces the old ES5 IIFE namespace pattern.
export type StorefrontRoot = Record<string, any>;

export const storefront: StorefrontRoot = (globalThis as any).storefront ?? ((globalThis as any).storefront = {});

// Optional: also expose the existing SF global if present (legacy code expects it).
export const SF: any = (globalThis as any).SF ?? ((globalThis as any).SF = {});

export class EditorStateService {

}

export class ToolTip {

}
